import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import Icon from '../../common/icons/Icon';
import { Modal } from 'synfrastructure';
import AddForm from '../../common/forms/AddForm';
import {
  fetchCategories,
  setCategoryActivity,
  setCategoryName,
  addSection,
  deleteSection,
  updateCategoryThumbnail,
  reorderSections,
  setCategoryCourse,
} from '../actions';
import { SubmissionError, reset } from 'redux-form';
import { formatValidationErrors } from '../../common/utils/getApiReducer';
import Breadcrumb from '../../common/components/Breadcrumb';
import { Checkbox } from 'synfrastructure';
import ToggleScaffold from '../../common/forms/ToggleScaffold';
import DeleteForm from '../../common/forms/DeleteForm';
import dataUrlToFile from '../../common/utils/dataUrlToFile';
import CategoryEditForm from './CategoryEditForm';
import SortableListWrapper from '../../common/components/SortableListWrapper';

import { selectActiveCategory, selectActiveCategorySections } from '../selectors';

class CategoryDetailPage extends Component {
  static propTypes = {
    category: PropTypes.object,
  };

  constructor(props) {
    super(props);

    this.state = {
      addSectionModalVisible: false,
      clearOrigImage: false,
      deleteSectionId: null,
      deleteSectionModalVisible: false,
      deleteSectionName: null,
      editing: false,
    };
  }

  toggleAddSectionModal = () => {
    this.setState({ addSectionModalVisible: !this.state.addSectionModalVisible });
  };

  toggleEdit = () => {
    this.setState(state => ({
      editing: !state.editing,
      clearOrigImage: false,
    }));
  };

  onEditCategorySubmit = values => {
    const { dispatch, match: { params: { categoryId } } } = this.props;

    if (values.image) {
      values.image = dataUrlToFile(values.image.imageResult, values.image.imageFilename);

      return dispatch(updateCategoryThumbnail(categoryId, values)).then(action => {
        if (!action.response.ok) {
          throw new SubmissionError(formatValidationErrors(action.json).toJS());
        } else {
          this.setState(state => ({ editing: false }));
        }
      });
    } else {
      this.setState(state => ({ editing: false }));

      return Promise.resolve();
    }
  };

  removeImage = () => {
    this.setState(state => ({ clearOrigImage: true }));
  };

  toggleDeleteSectionModal = (sectionId, name) => {
    if (this.state.deleteSectionModalVisible) {
      this.props.dispatch(reset('deleteForm'));
      this.setState(state => ({
        deleteSectionId: null,
        deleteSectionModalVisible: false,
        deleteSectionName: null,
      }));
    } else {
      this.setState(state => ({
        deleteSectionId: sectionId,
        deleteSectionModalVisible: true,
        deleteSectionName: name,
      }));
    }
  };

  onDeleteSectionSubmit = () => {
    const { dispatch, match } = this.props;

    return dispatch(deleteSection(match.params.categoryId, this.state.deleteSectionId)).then(action => {
      if (!action.response.ok) {
        throw new SubmissionError(formatValidationErrors(action.json).toJS());
      } else {
        this.toggleDeleteSectionModal();
      }
    });
  };

  onAddSectionSubmit = values => {
    const { dispatch, match } = this.props;

    return dispatch(addSection(match.params.categoryId, values.name)).then(action => {
      if (!action.response.ok) {
        throw new SubmissionError(formatValidationErrors(action.json).toJS());
      } else {
        dispatch(fetchCategories());
      }
    });
  };

  onCategoryActivitytoggle = () => {
    const { activeCategory, dispatch, match } = this.props;

    return dispatch(setCategoryActivity(match.params.categoryId, !activeCategory.get('active'))).then(action =>
      dispatch(fetchCategories())
    );
  };

  onCategoryCourseToggle = () => {
    const { activeCategory, dispatch, match } = this.props;

    return dispatch(setCategoryCourse(match.params.categoryId, !activeCategory.get('is_course'))).then(action => 
      dispatch(fetchCategories()) 
    );
  }

  onCategoryNameChange = (categoryId, name) => {
    const { dispatch } = this.props;

    if (name.length > 0) {
      return dispatch(setCategoryName(categoryId, name)).then(() => 
        dispatch(fetchCategories())
      )
    }
  }

  render() {
    const { activeCategory, dispatch, match, sections } = this.props;
    const {
      addSectionModalVisible,
      clearOrigImage,
      deleteSectionModalVisible,
      deleteSectionName,
      editing,
    } = this.state;

    const editCategory = activeCategory => {
      return (
        <div>
          <input type="text" value={activeCategory.get('name')} onChange={(e) => this.onCategoryNameChange(activeCategory.get('id'), e.target.value)} />
        </div>
      );
    }

    const breadcrumbs = [
      {
        label: 'Library',
        to: '/library',
      },
      {
        label: editCategory(activeCategory),
        to: null,
      },
    ];

    const renderedSections = sections.length ? (
      sections.map(section => {
        return (
          <li key={`section-${section.id}`}>
            <div className="admin-paper__list__title">{section.name}</div>
            <div className="admin-paper__list__actions">
              <Link to={`/library/${match.params.categoryId}/sections/${section.id}`}>
                <Icon icon="Pencil" />
              </Link>
              <button onClick={this.toggleDeleteSectionModal.bind(this, section.id, section.name)}>
                <Icon icon="Trash" />
              </button>
            </div>
          </li>
        );
      })
    ) : (
      <div className="admin-paper__no-content">No sections found</div>
    );
    const imageLocation =
      activeCategory.getIn(['image', 'location']) || activeCategory.getIn(['course', 'image', 'location']);
    return (
      <div>
        <div className="admin-paper">
          <Modal isVisible={addSectionModalVisible} onClose={this.toggleAddSectionModal}>
            <AddForm
              entityType="Section"
              initialValues={{ name: null }}
              onSubmit={this.onAddSectionSubmit}
              onCancel={this.toggleAddSectionModal}
            />
          </Modal>
          <Modal isVisible={deleteSectionModalVisible} onClose={this.toggleDeleteSectionModal}>
            <DeleteForm
              entityType="Section"
              initialValues={{ name: null }}
              onSubmit={this.onDeleteSectionSubmit}
              onCancel={this.toggleDeleteSectionModal}
              requiredConfirmationText={deleteSectionName}
            />
          </Modal>
          <div className="admin-paper__header">
            <Breadcrumb crumbs={breadcrumbs} />
            <ToggleScaffold label="Course">
            <Checkbox
                id={`Category-${activeCategory.get('id')}-active`}
                checked={activeCategory.get('is_course')}
                onChange={this.onCategoryCourseToggle}
              />
            </ToggleScaffold>
            <ToggleScaffold label="Active">
              <Checkbox
                id={`Category-${activeCategory.get('id')}-active`}
                checked={activeCategory.get('active')}
                onChange={this.onCategoryActivitytoggle}
              />
            </ToggleScaffold>
            <button onClick={this.toggleAddSectionModal} className="admin__add-button">
              <Icon icon="Plus" /> Add Section
            </button>
          </div>

          {editing ? (
            <CategoryEditForm
              clearOrigImage={clearOrigImage}
              onSubmit={this.onEditCategorySubmit}
              onCancel={this.toggleEdit}
              onDelete={this.onDelete}
              removeImage={this.removeImage}
              category={activeCategory}
            />
          ) : (
            <div>
              <div className="admin-paper__edit-content" key="show-info">
                <div className="admin-paper__edit-content__row">
                  <div className="admin-paper__edit-content__upload">
                    <p>Category Thumbnail</p>
                    {imageLocation ? (
                      <div className="admin__image-preview" style={{ backgroundImage: `url(${imageLocation})` }} />
                    ) : (
                      <div className="admin__image__placeholder image__placeholder">No Image</div>
                    )}
                  </div>
                </div>
                <div className="admin-paper__edit-button">
                  <button className="button" onClick={this.toggleEdit}>
                    Edit
                  </button>
                </div>
              </div>
            </div>
          )}
        </div>
        {!editing && (
          <SortableListWrapper
            items={sections}
            onSave={items => {
              return dispatch(
                reorderSections(match.params.categoryId, { sectionIds: items.map(section => section.id) })
              );
            }}
            title="Sections"
          >
            <ul className="admin-paper__list">{renderedSections}</ul>
          </SortableListWrapper>
        )}
      </div>
    );
  }
}

export default connect((state, ownProps) => {
  return {
    activeCategory: selectActiveCategory(state.library.categories, ownProps.match.params.categoryId),
    sections: selectActiveCategorySections(state.library.categories, ownProps.match.params.categoryId),
  };
})(CategoryDetailPage);



// WEBPACK FOOTER //
// ./src/library/categories/CategoryDetailPage.js